/* eslint-disable */

/**
 * Ein Eintrag in der Starter-Historie (Pferd oder Reiter)
 */
export interface StarterHistoryItemDto {
  startNo?: number | null
  horseName?: string | null
  horseRegisterId?: string | null
  horseGender?: string | null
  horseBirthday?: string | null
  horseBreedKz?: string | null
  horseBreed?: string | null
  horseFatherName?: string | null
  horseMotherName?: string | null
  riderFirstName?: string | null
  riderLastName?: string | null
  riderRegisterId?: string | null
  examId?: number | null
  examName?: string | null
  examType?: string | null
  showId?: number | null
  showName?: string | null
  showYear?: number | null
  place?: number | null
  igvPoints?: number | null
}

export function instanceOfStarterHistoryItemDto(value: object): value is StarterHistoryItemDto {
  return true
}

export function StarterHistoryItemDtoFromJSON(json: any): StarterHistoryItemDto {
  if (json == null) return json
  return {
    startNo:        json['startNo']        ?? undefined,
    horseName:      json['horseName']      ?? undefined,
    horseRegisterId:json['horseRegisterId']?? undefined,
    horseGender:    json['gender']         ?? undefined,
    horseBirthday:  json['birthday']       ?? undefined,
    horseBreedKz:   json['breedkz']        ?? undefined,
    horseBreed:     json['breed']          ?? undefined,
    horseFatherName:json['fatherName']      ?? undefined,
    horseMotherName:json['motherName']      ?? undefined,
    riderFirstName: json['riderFirstName'] ?? undefined,
    riderLastName:  json['riderLastName']  ?? undefined,
    riderRegisterId:json['riderRegisterId']?? undefined,
    examId:         json['examId']         ?? undefined,
    examName:       json['examName']       ?? undefined,
    examType:       json['examType']       ?? undefined,
    showId:         json['showId']         ?? undefined,
    showName:       json['showName']       ?? undefined,
    showYear:       json['showYear']       ?? undefined,
    place:          json['place']          ?? undefined,
    igvPoints:      json['igvPoints']      ?? undefined,
  }
}

export function StarterHistoryItemDtoToJSON(value?: StarterHistoryItemDto | null): any {
  if (value == null) return value
  return { ...value }
}
